/* eslint-disable */
import useSpaRouter from '@m2h/common/utils/spaRouter';
import React, { useState, useRef, Suspense, useEffect } from 'react';
import LoadingIcon from '@m2h/components/LoadingIcon';
import ErrorBoundary from './ErrorBoundary';
// import { useLocation } from 'react-router-dom';
// import Loading from './Loading';

import ErrorHtml from './ErrorBoundary/error'
import { owlReportMetrics } from '@m2h/common/raptor';
import RegionLocaleMismatchGuard from '@m2h/common/i18n/RegionLocaleMismatchGuard';

// const LoadingHtml = <Loading />
const handleError = (owlMetaKeys) => {
  const { CRASH: CRASH_KEY } = owlMetaKeys || {};
  if (CRASH_KEY) {
    owlReportMetrics({ [CRASH_KEY]: 1 });
  }
  console.log('handleError')
}


export default function (props: any) {
  // 设置全局spa路由utils
  useSpaRouter();

  const {
    component: Component, path, routes, store, storeIniter, onError, owlMetaKeys,
    errorBoundaryFallback = ErrorHtml,
    ...otherRoute
  } = props || {};

  return (
    // <ErrorBoundary fallback={errorBoundaryFallback || ErrorHtml} onError={() => (onError || handleError)(owlMetaKeys)}>
    <ErrorBoundary>
      <Suspense fallback={<LoadingIcon showBorder />}>
        <ErrorBoundary>
          <RegionLocaleMismatchGuard routePath={path} />
          <Component key={path} {...otherRoute} routes={routes} />
        </ErrorBoundary>
      </Suspense>
    </ErrorBoundary>
  );

  // const location = useLocation();
  //
  // const [showComp, setShowComp] = useState(false);
  // const showCompRef = useRef(false);
  //
  // // storeInited：useeffect 或 直出之一，执行过store逻辑
  // const storeInited = useRef(false);
  // const prePath = useRef(path);
  // const preComp = useRef(Component);
  //
  // const setShowCompStatus = (status) => {
  //   setShowComp(status);
  //   showCompRef.current = status;
  // }

  // useStoreInit(storeIniter);

  // const willMount = React.useRef(true);
  //
  // if (willMount.current) {
  //   if(globalThis.__MACH_PRO_STORE__) {
  //     if (showCompRef.current) {
  //       setShowCompStatus(false);
  //     }
  //     globalThis.__MACH_PRO_STORE__.store && (globalThis.__MACH_PRO_STORE__.store.inited = false);
  //     globalThis.__MACH_PRO_STORE__.store.resetModels();
  //     console.log(storeIniter);
  //     // SPA模式，sotre为全局单例，不刷页面切路由时，store不会重新初始化为跳转页面的路由
  //     storeIniter.forEach((r: any) => {
  //       r?.default && r?.default();
  //     })
  //     storeIniter
  //     setShowCompStatus(true);
  //   } else if (!showCompRef.current) {
  //     // 初次加载，路径无变化时
  //     setShowCompStatus(true);
  //     prePath.current = path;
  //   }
  // }

  // willMount.current = false;

  // useEffect(() => {
  //   willMount.current = true;
  // }, [
  //   path,
  //   Component,
  //   store,
  //   location.key,    // 添加 location.key 以响应所有导航变化
  //   location.pathname, // 添加 pathname 以确保路径变化时触发
  // ])

  // useEffect(() => {
  //   if(globalThis.__MACH_PRO_STORE__ && !storeInited.current) {
  //     if (showCompRef.current) {
  //       setShowCompStatus(false);
  //     }
  //     storeInited.current = true;
  //     globalThis.__MACH_PRO_STORE__.store && (globalThis.__MACH_PRO_STORE__.store.inited = false);
  //     globalThis.__MACH_PRO_STORE__.store.resetModels();
  //     // SPA模式，sotre为全局单例，不刷页面切路由时，store不会重新初始化为跳转页面的路由
  //     storeIniter.forEach((r: any) => {
  //       r?.default && r?.default();
  //     })
  //     setShowCompStatus(true);
  //     prePath.current = path;
  //     preComp.current = Component;
  //     storeInited.current = false;
  //   } else if (!showCompRef.current) {
  //     // 初次加载，路径无变化时
  //     setShowCompStatus(true);
  //     prePath.current = path;
  //     preComp.current = Component;
  //   }
  // }, [
  //   path,
  //   storeIniter,
  //   store,
  //   location.key,    // 添加 location.key 以响应所有导航变化
  //   location.pathname, // 添加 pathname 以确保路径变化时触发
  // ])

  // if(globalThis.__MACH_PRO_STORE__) {
  //   globalThis.__MACH_PRO_STORE__.store && (globalThis.__MACH_PRO_STORE__.store.inited = false);
  //   globalThis.__MACH_PRO_STORE__.store.resetModels();
  // }
  // // SPA模式，sotre为全局单例，不刷页面切路由时，store不会重新初始化为跳转页面的路由
  // storeIniter.forEach((r: any) => {
  //   r?.default && r?.default();
  // })
  // setShowCompStatus(true);
  // prePath.current = path;
  // storeInited.current = false;

  // 模拟willmount
  // if(globalThis.__MACH_PRO_STORE__ && prePath.current !== path && !storeInited.current) {
  //   if (showCompRef.current) {
  //     setShowCompStatus(false);
  //   }
  //   storeInited.current = true;
  //   globalThis.__MACH_PRO_STORE__.store && (globalThis.__MACH_PRO_STORE__.store.inited = false);
  //   globalThis.__MACH_PRO_STORE__.store.resetModels();
  //   // SPA模式，sotre为全局单例，不刷页面切路由时，store不会重新初始化为跳转页面的路由
  //   Promise.all(store?.map(s => s())).then((res) => {
  //     console.log(res, 'pp');
  //     res.forEach((r: any) => {
  //       r?.default && r?.default();
  //     })
  //     setShowCompStatus(true);
  //     // prePath.current = path;
  //     preComp.current = Component;
  //     storeInited.current = false;
  //   })
  // } else if (showCompRef.current && prePath.current !== path) {
  //   prePath.current = path
  // }

  // return (
  //   <Suspense fallback={<Loading />}>
  //     <Component key={path} {...otherRoute} routes={routes} />
  //     {/*{showComp && showCompRef.current && prePath.current === path ?<Component {...otherRoute} routes={routes} /> : null}*/}
  //     {/*{prePath.current === path ? <Component {...otherRoute} routes={routes} /> : <preComp.current {...otherRoute} routes={routes} />}*/}
  //     {/*{showComp && showCompRef.current && prePath.current === path ? <Component {...otherRoute} routes={routes} /> : <div>null---------</div>}*/}
  //     {/*{showComp && showCompRef.current ? <Component {...otherRoute} routes={routes} /> : <div>null---------</div>}*/}
  //   </Suspense>
  // );
}
